import { useState } from 'react';
import { Alert, Button, Modal } from 'antd';
import { Copy } from 'lucide-react';
import { copyToClipboard } from '@/utils/utils';
import type { RevealedToken } from './ChannelAccountFormDrawer';

interface MultiTokenRevealDialogProps {
  open: boolean;
  tokens: RevealedToken[];
  onClose: () => void;
}

/** 多 Token 一次性明文展示：WebSocket 渠道账号创建时可同步签发多个 token，
 *  关闭后无法找回，需逐个提示复制。样式复用 credentials.css 的 .reveal-* 类。 */
export default function MultiTokenRevealDialog({
  open,
  tokens,
  onClose,
}: MultiTokenRevealDialogProps) {
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null);

  async function onCopy(index: number, token: string) {
    const ok = await copyToClipboard(token);
    if (ok) setCopiedIndex(index);
  }

  return (
    <Modal
      title={`Token 已生成（仅此一次明文，共 ${tokens.length} 个）`}
      open={open}
      onCancel={onClose}
      maskClosable={false}
      width={560}
      footer={
        <Button type="primary" onClick={onClose}>
          已复制 · 关闭
        </Button>
      }
      afterClose={() => setCopiedIndex(null)}
    >
      <Alert
        type="warning"
        showIcon
        message={<b>请立即复制保存。</b>}
        description={
          <>
            关闭后将以 <code>***</code>{' '}
            形式脱敏，无法找回。如果忘记，需在「凭证管理」中重置生成新的。
          </>
        }
      />
      {tokens.map((t, i) => (
        <div key={i}>
          <div className="reveal-name">{t.name}</div>
          <div className="reveal-token">
            <code>{t.token}</code>
            <Button icon={<Copy size={14} />} onClick={() => onCopy(i, t.token)}>
              {copiedIndex === i ? '已复制' : '复制'}
            </Button>
          </div>
        </div>
      ))}
    </Modal>
  );
}
